export default "__VITE_ASSET__CJN6p5mC__"